import React from 'react'
import renderContent from '../../utilities/renderContent'
import './style.css'
import { Parallax } from 'react-parallax';

// import imgTreatment from './images/*'



// function importAll(r) {
//   return r.keys().map(r);
// }

// const images = importAll(require.context('./images', false, /\.(png|jpe?g|svg)$/));


const TreatmentList = ({ treatments }) => {
  console.log('Treatment.treatments'. treatments)

  return (
    <div className="treatments">
      <div className="container">
        <h1>Treatments</h1>
        {
          Object.keys(treatments).map((key) => {
            const treatment = treatments[key]

            return (
              <div key={key}>
                <h3>{treatment.name}</h3>
                {treatment.content &&
                  <div>
                    {renderContent(treatment.content)}
                  </div>
                }
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

const Treatment = ({ treatment }) => {
  console.log('Treatment.treatment', treatment)
  var image_dom = null;
  if (treatment.images != undefined){
    image_dom = treatment.images.map(function(image, key){
        return (
          <img src={image}
            className="image-treatment"
            draggable="false"
            alt={treatment.name}
            key={key}
          />
        )
      }
    )
  }
  return (
    <div className="treatment">
      <div className="page-bg">
        {/* treatment.images[0] */}
        <Parallax bgImage="../images/treatments/00.jpg" strength={150} className="page-parallax">
        </Parallax>
      </div>
      <div className="container container-parallax">
        <div className="parallax-container">
          <div className="content">
            <div className="left">
              {image_dom}
            </div>
            <div className="right">
              <div className="treatment-title">{treatment.name}</div>
              {renderContent(treatment.content)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const Treatments = ({ data, match }) => {
  if (match && match.params.treatmentId !== undefined && data.treatments[match.params.treatmentId] !== undefined) {
    return <Treatment treatment={data.treatments[match.params.treatmentId]} />
  } else {
    return <TreatmentList treatments={data.treatments} />
  }
}

export default Treatments



// WEBPACK FOOTER //
// ./src/components/Treatments/index.js